import styled from 'styled-components';

export const MasterCircleGraphContainer = styled.div`
  -webkit-flex : auto;
  flex: auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 10px 0px;
`;

export const ChartConatiner = styled.div`
  width: 250px;
  height: 175px;
  border-radius: 20px;
  background: #2F3B49;
  overflow: hidden;
  padding-top: 20px;
  text-align: center;
`;
